import React from 'react';
import { StyleSheet } from './base_components';

import ProgressSpinner from './progress_spinner';
import Select from './select';

import PlanStore from '../stores/plan_store';

const styles = StyleSheet.create({
  planSelect: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: 'var(--input-text-color)',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: 'var(--input-border-color)',
    backgroundColor: 'var(--input-bg-color)',
  },
  spinner: {
    margin: '1rem',
    width: '2rem',
    height: '2rem',
  },
});

type Props = {
  style?: any;
  value: any;
  onChange: any;
};
export default function PlanSelect(props: Props) {
  const { style, value, onChange, ...other } = props;
  const list = PlanStore.usePlanList();
  React.useEffect(() => {
    PlanStore.fetch();
  }, []);

  function _onChange(new_value) {
    onChange(new_value);
  }

  let content: any = null;
  if (!list) {
    content = <ProgressSpinner />;
  } else {
    const options = list.map((p) => ({
      value: p.plan_id,
      text: `${p.plan_name} (${p.plan_id})`,
    }));

    content = (
      <Select
        style={[styles.planSelect, style]}
        options={options}
        value={value}
        onChange={_onChange}
        {...other}
      />
    );
  }
  return content;
}
